import { createApp, h } from 'vue'
import { createInertiaApp } from '@inertiajs/vue3'
import Echo from 'laravel-echo'
// import axios from 'axios'

import Donut from 'vue-css-donut-chart';
import 'vue-css-donut-chart/dist/vcdonut.css';

window.Pusher = require('pusher-js');
if (process.env.MIX_PUSHER_APP_KEY && process.env.MIX_PUSHER_APP_CLUSTER) {
    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        forceTLS: true
    });
}

// Tambahkan state global untuk menuVisibility
// const menuVisibility = ref(true);

// const fetchMenuVisibility = async () => {
//     try {
//         const response = await axios.get('/menu-visibility');
//         menuVisibility.value = response.status === 200 && response.data === true;
//     } catch (error) {
//         console.error('Error fetching menu visibility:', error);
//         menuVisibility.value = false; // Sembunyikan menu jika gagal
//     }
// };

createInertiaApp({
    progress: {
        delay: 100,
        color: '#3c4858',
        includeCSS: true,
        showSpinner: true,
    },
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title}` : ``,
    setup({ el, App, props, plugin }) {
        // fetchMenuVisibility();

        createApp({ render: () => h(App, props) })
            .mixin({ methods: { route: route } })
            .mixin(require('./base'))
            // .provide('menuVisibility', menuVisibility)
            .use(plugin)
            .use(Donut)
            .mount(el);
    },
});
